import { configureStore } from '@reduxjs/toolkit';
import ConstantDropdownSlice from './slices/constantDropdown';
import dailyAttendanceSlice from './slices/dailyAttendanceSlice';
import PayPeriodSlice from './slices/payPeriodSlice';
import payrollSettingWizardSlice from './slices/payrollSettingWizardSlice';
import profileSlice from './slices/profileSlice';
import currencySlice from './slices/usdCurrencyToggleSlice';
import ocrTimeLogsSlice from './slices/OcrTimeLogsSlice';
import monthlySummarySlice from './slices/monthlySummary';

const store = configureStore({
	reducer: {
		userProfile: profileSlice.reducer,
		constantDropdown: ConstantDropdownSlice.reducer,
		payrollSettingWizard: payrollSettingWizardSlice.reducer,
		payPeriod: PayPeriodSlice.reducer,
		usdCurrencyToggle: currencySlice.reducer,
		dailyAttendance: dailyAttendanceSlice.reducer,
		monthlySummary: monthlySummarySlice.reducer,
		ocrTimeLogs: ocrTimeLogsSlice.reducer,
	},
});

export default store;
export type AppDispatch = typeof store.dispatch;
